module.exports = __webpack_public_path__ + "img/logo.3fed7be9.png";